import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-terminos',
  templateUrl: './terminos.component.html',
  styleUrls: ['./terminos.component.scss']
})
export class TerminosComponent implements OnInit {
  privacyUrl = 'https://www.tecgurus.net/privacidad.html';

  constructor(private title: Title, private meta: Meta) {}

  ngOnInit(): void {
    this.title.setTitle('Términos y Aviso de Privacidad | TG Empleos');
    this.meta.updateTag({ name: 'description', content: 'Términos de uso y aviso de privacidad de TG Empleos por Tec Gurus.' });
    this.meta.updateTag({ name: 'robots', content: 'index,follow' });
  }
}
